
export class AfterHoursPOConfirmData 
{
    requestorId: string;
    supplierId: string;
    supplierLocationId: string;
}
